<template>
  <div class="FilterBoxAppAccou box-filter">
    <el-form :model="ruleForm" ref="ruleForm" @submit.prevent v-on:submit.prevent>
      <el-row type="flex" class="row-bg" justify="end">
        <el-col :xs="24" :span="5">
        </el-col>
        <el-col :xs="24" :span="4">
          <el-badge is-dot class="item" style="width: 100%" :hidden="!statusClearFilter">
            <el-button type="default" size="large" @click="viewFilter = !viewFilter" style="width: 100%">
              Mais Filtros
            </el-button>
          </el-badge>
        </el-col>
      </el-row>
      <div v-show="viewFilter" class="viewFilter">
        <el-row :gutter="20">
          <el-col :sm="12" :md="12">
            <el-form-item prop="person_id" label="ID">
              <el-input v-model="ruleForm.person_id" style="width: 100%" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Itens por página">
              <el-input-number style="width: 100%" :controls="false" v-model="ruleForm.per_page" :min="0" :max="99999"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-col :xs="24" :span="15">
            <el-button  native-type="submit" @click.prevent='searchTable' type="primary" size="large" style="float: right">
              Filtrar
            </el-button>
            <el-button v-if="statusClearFilter" @click='clearSearch' type="default" size="large" style="float: right; margin-right: 20px">
              Limpar Filtros
            </el-button>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
import {XIcon} from "vue-feather-icons";
import SelectSearchMarketplace from "@/app/components/Marketplace/SelectSearchMarketplace";
import SelectSearchRepresentante from "@/app/components/Representante/SelectSearchRepresentante";
import SelectSearchModeloEquipamento from "@/app/components/ModeloEquipamento/SelectSearchModeloEquipamento";

export default {
  name: "FilterBoxAppAccou",
  components: {
  },
  data () {
    return {
      loadingPage: true,
      ruleForm: {
        person_id: null,
        per_page: 25,
      },
      viewFilter: false,
    }
  },
  props: {
    currentPage: {
      type: Number,
      default: 1
    },
    type: {
      type: Number,
      default: 0
    }
  },
  computed: {
    statusClearFilter: function () {
      if (this.ruleForm.person_id ||
          (this.ruleForm.per_page !== 25)) {
        return true
      }
      return false
    }
  },
  methods: {
    clearSearch () {
      this.viewFilter = false
      this.ruleForm = {
        person_id: null,
        per_page: 25,
      }
      this.$emit('filter', `?page=${this.currentPage}`)
    },
    searchTable () {
      let query = `?page=${this.currentPage}`

      if (this.ruleForm.person_id) {
        query = `${query}&person_id=${this.ruleForm.person_id}`
      }
      if (this.ruleForm.per_page) {
        query = `${query}&per_page=${this.ruleForm.per_page}`
      }
      this.$emit('filter', query)
    },
  }
}
</script>

<style scoped>

</style>
